import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  useMediaQuery,
  useTheme,
  Stack,
  Paper,
  IconButton,
} from "@mui/material";
import CommonKpisBox from "../../../components/CommonKpisBox";
import Grid from "@mui/material/Grid2";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CallTable from "./CallTable";
import LeaderBoard from "./Leaderboard.js";
import Parameters from "./Parameters.js";
import { formatDuration } from "../../../utils/common.js";
import { jwtDecode } from "jwt-decode";
import Graph from "./Graph.js";
import CommonFilter from "../../../components/CommonFilter.js";
import Loader from "../../../components/AnimatedLoader.js";
import axiosInstance from "../../../services/axiosInterceptors.js";
import apiEndPointsConfig from "../../../services/apiEndPoints.js";
import { palette, theme as colorTheme } from "../../../Convoze.theme.js";
import ParentWrapper from "../../../components/ParentWrapper.jsx";





function AgentDashBoard() {
  const [dashboardData, setDashboardData] = useState();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const stored = localStorage.getItem("AgentDashboard");
  const decodedFilterData = stored ? JSON.parse(atob(stored)) : " ";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isFilter = { date: true, filter: false };
  const [payloadData, setPayloadData] = useState();
  const [loading, setLoading] = useState(true);

  const primary = colorTheme('palette', 'primary').value;
  const primaryBg = colorTheme('palette', 'primaryBg').value;
  const positive = colorTheme('palette', 'positive').value;
  const negative = colorTheme('palette', 'negative').value;
  const neutral = colorTheme('palette', 'neutral').value;

  const cardsData = [
    {
      title: "Total Calls",
      value: dashboardData?.dashboardMatrics?.totalCalls
        ? `${Math.round(dashboardData?.dashboardMatrics?.totalCalls)}`
        : "0",
      icon: "PhoneIcon",
      iconBgColor: "#DBEAFE",
      // iconColor: "#2196f3",
      iconColor: primary,
      trend: {
        direction:
          dashboardData?.trendMetrics?.totalCallsTrend?.direction == "decrease"
            ? "down"
            : dashboardData?.trendMetrics?.totalCallsTrend?.direction ==
              "increase"
              ? "up"
              : "no change",
        value: dashboardData?.trendMetrics?.totalCallsTrend?.percent
          ? `${dashboardData?.trendMetrics?.totalCallsTrend?.percent}%`
          : "0",
        note: "vs Last period",
      },
    },
    {
      title: "Avg. Sentiment Score",
      value: dashboardData?.dashboardMatrics?.overallSentimentScore
        ? `${dashboardData?.dashboardMatrics?.overallSentimentScore.toFixed(
          1
        )}%`
        : "0",
      icon: "SentimentSatisfiedAlt",
      iconBgColor: "#DCFCE7",
      // iconColor: "#4caf50",
      iconColor: positive,
      trend: {
        direction:
          dashboardData?.trendMetrics?.overallSentimentScoreTrend?.direction ==
            "decrease"
            ? "down"
            : dashboardData?.trendMetrics?.overallSentimentScoreTrend
              ?.direction == "increase"
              ? "up"
              : "no change",
        value:
          dashboardData?.trendMetrics?.overallSentimentScoreTrend?.percent || 0,
        note: "vs Last period",
      },
    },
    decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08"
      ? {
        title: "Conversion Status",
        value: dashboardData?.dashboardMatrics?.conversionRate
          ? Math.round(dashboardData.dashboardMatrics.conversionRate) === 0
            ? "0"
            : `${Math.round(dashboardData.dashboardMatrics.conversionRate)}%`
          : "0",
        icon: "TrendingUpIcon",
        iconBgColor: "#E8F5E9",
        iconColor: positive,
        trend: {
          direction:
            dashboardData?.trendMetrics?.conversionRateTrend?.direction ===
              "decrease"
              ? "down"
              : dashboardData?.trendMetrics?.conversionRateTrend?.direction ===
                "increase"
                ? "up"
                : "no change",
          value: dashboardData?.trendMetrics?.conversionRateTrend?.percent
            ? `${dashboardData.trendMetrics.conversionRateTrend.percent}%`
            : "0",
          note: "vs Last period",
        },
      }
      : {
        title: "Resolution Rate",
        value: dashboardData?.dashboardMatrics?.resolutionRate
          ? Math.round(dashboardData.dashboardMatrics.resolutionRate) === 0
            ? "0"
            : `${Math.round(dashboardData.dashboardMatrics.resolutionRate)}%`
          : "0",
        icon: "CheckCircleOutlineIcon",
        iconBgColor: "#F3E8FF",
        iconColor: positive,
        trend: {
          direction:
            dashboardData?.trendMetrics?.resolutionRateTrend?.direction ===
              "decrease"
              ? "down"
              : dashboardData?.trendMetrics?.resolutionRateTrend?.direction ===
                "increase"
                ? "up"
                : "no change",
          value: dashboardData?.trendMetrics?.resolutionRateTrend?.percent
            ? `${dashboardData.trendMetrics.resolutionRateTrend.percent}%`
            : "0",
          note: "vs Last period",
        },
      },
    {
      title: "Avg. Silence Duration",
      value: dashboardData?.dashboardMatrics?.formattedSilenceDuration
        ? formatDuration(
          dashboardData?.dashboardMatrics?.formattedSilenceDuration
        )
        : "0",
      icon: "Timer",
      iconBgColor: "#FFEDD5",
      // iconColor: "#EA580C",
      iconColor: negative,
      trend: {
        direction:
          dashboardData?.trendMetrics?.formattedSilenceDuration?.direction ==
            "decrease"
            ? "down"
            : dashboardData?.trendMetrics?.formattedSilenceDuration
              ?.direction == "increase"
              ? "up"
              : "no change",

        value:
          dashboardData?.trendMetrics?.formattedSilenceDuration?.percent || 0,
        note: "vs Last period",
      },
    },
    {
      title: "Talk Ratio(%)",
      value: dashboardData?.dashboardMatrics?.talkRatio
        ? `${Math.round(dashboardData?.dashboardMatrics?.talkRatio)}%`
        : "00:00",
      icon: "RecordVoiceOver",
      iconBgColor: "#e3f2fd",
      // iconColor: "#2563EB",
      iconColor: primary,
      trend: {
        direction:
          dashboardData?.trendMetrics?.talkRatioTrend?.direction == "decrease"
            ? "down"
            : dashboardData?.trendMetrics?.talkRatioTrend?.direction ==
              "increase"
              ? "up"
              : "no change",
        value: dashboardData?.trendMetrics?.talkRatioTrend?.percent
          ? `${dashboardData?.trendMetrics?.talkRatioTrend?.percent}%`
          : "0",
        note: "vs Last period",
      },
    },
  ];

  useEffect(() => {
    fetchDashboardDetails();
  }, [payloadData]);

  const fetchDashboardDetails = async () => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
    };
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentDashboard,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDashboardData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode) {
        if (statusCode === 401) {
          localStorage.clear();
        }
      } else {
        console.error("No error code received from the server");
      }
    }
  };

  return (
    // <Box
    //   sx={{
    //      ml: {
    //       xs: "0px",
    //       md: "230px",
    //     },
    //     p: 3,
    //     display: "flex",
    //     flexDirection: "column",
    //     gap: 2,
    //   }}
    // >
    //   {loading ? (
    //     <Loader />
    //   ) : (
    //     <Grid container spacing={2.5} sx={{}}>
    //       <Grid
    //         item
    //         size={{ xs: 12 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <Box
    //           sx={{
    //             display: "flex",
    //             justifyContent: "space-between",
    //             alignItems: "flex-start",
    //             flexDirection: isMobile ? "column" : "row",
    //             gap: 2,
    //           }}
    //         >
    //           <Box>
    //             <Typography
    //               variant="h5"
    //               sx={{
    //                 fontFamily:
    //                   "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    //                 fontWeight: 700,
    //               }}
    //               gutterBottom
    //             >
    //               Hey,{" "}
    //               {dashboardData?.dashboardMatrics?.agentName ||
    //                 decodedToken?.userName}
    //             </Typography>
    //             <Typography variant="subtitle1" color="text.secondary">
    //               {new Date().toLocaleDateString("en-US", {
    //                 weekday: "long",
    //                 year: "numeric",
    //                 month: "long",
    //                 day: "numeric",
    //               })}
    //             </Typography>
    //           </Box>
    //           <CommonFilter
    //             setPayloadData={setPayloadData}
    //             storageName={"AgentDashboard"}
    //             isFilter={isFilter}
    //           />
    //         </Box>
    //         {/* <Paper
    //         sx={{
    //           p: 1.5,
    //           border: "1px solid #e0e0e0",
    //           borderRadius: 2,
    //           display: "flex",
    //           flexDirection: { xs: "column", md: "row" },
    //           justifyContent: "space-between",
    //           alignItems: { xs: "flex-start", md: "center" },
    //           gap: { xs: 1, md: 0 },
    //         }}
    //       >
    //         <Box
    //           sx={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: 2,
    //           }}
    //         >
    //           <Box
    //             sx={{
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //               bgcolor: "#F0F1FE",
    //               borderRadius: "50%",
    //               width: 80,
    //               height: 80,
    //             }}
    //           >
    //             <Typography
    //               variant="h4"
    //               component="div"
    //               fontWeight="bold"
    //               color="#6366F1"
    //             >
    //               85
    //             </Typography>
    //           </Box>
    //           <Box>
    //             <Typography
    //               variant="body1"
    //               component="div"
    //               fontWeight="bold"
    //               fontSize={18}
    //             >
    //               Overall Performance Score
    //             </Typography>
    //             <Typography variant="body2" color="text.secondary">
    //               Based on 127 calls in the last 7 days
    //             </Typography>
    //           </Box>
    //         </Box>
    //         <Box
    //           sx={{
    //             display: "flex",
    //             alignItems: "center",
    //           }}
    //         >
    //           <ArrowUpward sx={{ color: "success.main", mr: 0.5 }} />
    //           <Typography
    //             variant="body2"
    //             color="success.main"
    //             fontWeight="medium"
    //           >
    //             4 points
    //           </Typography>
    //           <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
    //             vs previous period
    //           </Typography>
    //           <IconButton size="small">
    //             <InfoOutlinedIcon sx={{ color: "#6366F1", fontSize: 20 }} />
    //           </IconButton>
    //         </Box>
    //       </Paper> */}
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12 }}
    //         sx={{ display: "flex", justifyContent: "space-between" }}
    //       >
    //         <Box
    //           sx={{
    //             // border: "1px solid #eee",
    //             display: "flex",
    //             alignItems: "flex-end",
    //             // boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
    //           }}
    //         >
    //           <Typography
    //             variant="h6"
    //             component="h3"
    //             fontWeight="600"
    //             color="text.primary"
    //             sx={{ color: primary, fontSize: 16 }}
    //           >
    //             {decodedFilterData?.appliedFilters?.length > 0
    //               ? `${decodedFilterData?.appliedFilters[0]?.label}'s Performance`
    //               : "Today's Performance"}{" "}
    //           </Typography>
    //         </Box>
    //         <Box
    //           sx={{
    //             borderRadius: 2,
    //             border: "1px solid #eee",
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "space-between",
    //             p: 2,
    //             boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
    //             backgroundColor: "#fff",
    //             gap: 2,
    //           }}
    //         >
    //           <Stack spacing={0.5}>
    //             <Typography variant="body2" color="text.secondary">
    //               {/* {decodedFilterData?.appliedFilters?.length > 0
    //               ? `${decodedFilterData?.appliedFilters[0]?.label}'s Performance`
    //               : "Today's Performance"} */}
    //               Performance
    //             </Typography>
    //             <Typography variant="h5" fontWeight={600} color={primary}>
    //               {(dashboardData?.dashboardMatrics?.agentOverAllScore &&
    //                 Math.round(
    //                   dashboardData?.dashboardMatrics?.agentOverAllScore
    //                 )) ||
    //                 0}
    //               <Typography variant="body2" component="span" color={primary}>
    //                 %
    //               </Typography>
    //             </Typography>
    //           </Stack>

    //           <Box
    //             sx={{
    //               backgroundColor: "#E0E1FD	",
    //               width: 50,
    //               height: 50,
    //               borderRadius: "50%",
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //             }}
    //           >
    //             <TrendingUpIcon sx={{ color: {primary} }} />
    //           </Box>
    //         </Box>
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <Grid container spacing={2}>
    //           <CommonKpisBox cardsData={cardsData} cardLength={2.4} />
    //         </Grid>
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12, md: 8 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <Graph graphData={dashboardData?.agentPerformanceTrend} />
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12, md: 4 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <LeaderBoard
    //           isAgent={decodedToken}
    //           dashboardLeaderboardData={dashboardData?.performanceLeaderborad}
    //         />
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12, md: 8 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <CallTable tableData={dashboardData?.recentCalls} />
    //       </Grid>
    //       <Grid item size={{ xs: 12, md: 4 }}>
    //         <Parameters parametersData={dashboardData?.parameterBreakdown} />
    //       </Grid>
    //     </Grid>
    //   )}
    // </Box>

    <ParentWrapper>

      {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={2.5} sx={{}}>
          <Grid
            item
            size={{ xs: 12 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontWeight: 700,
                  }}
                  gutterBottom
                >
                  Hey,{" "}
                  {dashboardData?.dashboardMatrics?.agentName ||
                    decodedToken?.userName}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </Typography>
              </Box>
              <CommonFilter
                setPayloadData={setPayloadData}
                storageName={"AgentDashboard"}
                isFilter={isFilter}
              />
            </Box>
            {/* <Paper
            sx={{
              p: 1.5,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", md: "center" },
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "#F0F1FE",
                  borderRadius: "50%",
                  width: 80,
                  height: 80,
                }}
              >
                <Typography
                  variant="h4"
                  component="div"
                  fontWeight="bold"
                  color="#6366F1"
                >
                  85
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body1"
                  component="div"
                  fontWeight="bold"
                  fontSize={18}
                >
                  Overall Performance Score
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Based on 127 calls in the last 7 days
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <ArrowUpward sx={{ color: "success.main", mr: 0.5 }} />
              <Typography
                variant="body2"
                color="success.main"
                fontWeight="medium"
              >
                4 points
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                vs previous period
              </Typography>
              <IconButton size="small">
                <InfoOutlinedIcon sx={{ color: "#6366F1", fontSize: 20 }} />
              </IconButton>
            </Box>
          </Paper> */}
          </Grid>
          <Grid
            item
            size={{ xs: 12 }}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box
              sx={{
                // border: "1px solid #eee",
                display: "flex",
                alignItems: "flex-end",
                // boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Typography
                variant="h6"
                component="h3"
                fontWeight="600"
                color="text.primary"
                sx={{ color: primary, fontSize: 16 }}
              >
                {decodedFilterData?.appliedFilters?.length > 0
                  ? `${decodedFilterData?.appliedFilters[0]?.label}'s Performance`
                  : "Today's Performance"}{" "}
              </Typography>
            </Box>
            <Box
              sx={{
                borderRadius: 2,
                border: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2,
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#fff",
                gap: 2,
              }}
            >
              <Stack spacing={0.5}>
                <Typography variant="body2" color="text.secondary">
                  {/* {decodedFilterData?.appliedFilters?.length > 0
                  ? `${decodedFilterData?.appliedFilters[0]?.label}'s Performance`
                  : "Today's Performance"} */}
                  Performance
                </Typography>
                <Typography variant="h5" fontWeight={600} color={primary}>
                  {(dashboardData?.dashboardMatrics?.agentOverAllScore &&
                    Math.round(
                      dashboardData?.dashboardMatrics?.agentOverAllScore
                    )) ||
                    0}
                  <Typography variant="body2" component="span" color={primary}>
                    %
                  </Typography>
                </Typography>
              </Stack>

              <Box
                sx={{
                  backgroundColor: "#E0E1FD	",
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TrendingUpIcon sx={{ color: { primary } }} />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            size={{ xs: 12 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Grid container spacing={2}>
              <CommonKpisBox cardsData={cardsData} cardLength={2.4} />
            </Grid>
          </Grid>
          <Grid
            item
            size={{ xs: 12, md: 8 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Graph graphData={dashboardData?.agentPerformanceTrend} />
          </Grid>
          <Grid
            item
            size={{ xs: 12, md: 4 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <LeaderBoard
              isAgent={decodedToken}
              dashboardLeaderboardData={dashboardData?.performanceLeaderborad}
            />
          </Grid>
          <Grid
            item
            size={{ xs: 12, md: 8 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <CallTable tableData={dashboardData?.recentCalls} />
          </Grid>
          <Grid item size={{ xs: 12, md: 4 }}>
            <Parameters parametersData={dashboardData?.parameterBreakdown} />
          </Grid>
        </Grid>
      )}
    </ParentWrapper>
  );
}

export default AgentDashBoard;
